import axiosClient from './axiosClient';

export const userAPI = {
  getCurrentUser: () => {
    return axiosClient.get('/user/me');
  },
};